export default __webpack_public_path__ + "static/barlow-v4-latin-regular-dee20f8f54a7ea4c601987f07c99539f.eot";